module.exports = __webpack_public_path__ + "static/media/Logo.86187a8a.svg";